import { SxProps } from '@mui/material';

export const LoginPageStyles = {
  mainContainer: {
    minHeight: '111.11vh',
    background: `
      linear-gradient(to bottom, rgba(227, 248, 255, 0.8), rgba(120, 162, 240, 0.8)),
      url('https://res.cloudinary.com/dh0eho4vx/image/upload/v1759968947/tree_high_resolution_vd6ztw.png')
    `,
    backgroundSize: '120%',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: { xs: '1rem', md: '2rem' },
  },
  loginContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '0.75rem',
    width: '100%',
    maxWidth: '420px',
    padding: { xs: '1.5rem', md: '2rem' },
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    borderRadius: '20px',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
  },
  rightContainer: {
    minHeight: '100%',
    minWidth: '50%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    paddingBottom: '50px',
    background: 'rgb(244, 249, 255)',
  },
  leftContainer: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: '100px',
    minHeight: '111.11vh',
    minWidth: '50%',
  },
  imageContainer: {
    display: 'flex',
    marginTop: '130px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  sloganFont: {
    fontFamily: '"BD Sans", sans-serif',
    fontSize: '1.5rem',
    fontWeight: 600,
    color: 'rgb(23, 31, 57)',
    textShadow: '1px 1px 3px rgba(20, 24, 39, 0.15)',
    lineHeight: 1.1,
    marginBottom: '8px',
    textTransform: 'uppercase',
  },
  logoTitleRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px',
    marginBottom: '20px',
  },
  logo: {
    width: 60,
    height: 60,
  },
  title: {
    fontFamily: '"Higuen Serif", serif',
    fontWeight: 600,
    fontSize: '2rem',
    color: '#333',
    textAlign: 'center',
    lineHeight: 1.1,
    margin: 0,
    padding: 0,
    letterSpacing: 1,
  },
  subtitle: {
    fontSize: '1.1rem',
    color: 'rgba(102, 126, 234, 0.8)',
    textAlign: 'center',
    marginTop: '8px',
    marginBottom: '24px',
    fontFamily: '"Poppins", sans-serif',
    fontWeight: 500,
    letterSpacing: 0.3,
    lineHeight: 1.4,
  },
  textField: {
    width: '100%',
    '& .MuiOutlinedInput-root': {
      borderRadius: '12px',
      backgroundColor: 'rgba(255, 255, 255, 0.8)',
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
      },
      '&.Mui-focused': {
        backgroundColor: 'rgba(255, 255, 255, 1)',
      },
    },
    '& .MuiInputLabel-root': {
      fontFamily: '"Poppins", sans-serif',
      fontWeight: 500,
    },
  },
  passwordField: {
    borderRadius: '12px',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.9)',
    },
    '&.Mui-focused': {
      backgroundColor: 'rgba(255, 255, 255, 1)',
    },
  },
  button: {
    width: '100%',
    padding: '12px 24px',
    background: 'linear-gradient(135deg, #667eea, #764ba2)',
    color: '#fff',
    borderRadius: '12px',
    fontSize: '1rem',
    fontWeight: 600,
    fontFamily: '"Poppins", sans-serif',
    textTransform: 'none',
    boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)',
    transition: 'all 0.2s ease',
    '&:hover': {
      background: 'linear-gradient(135deg, #5a6fd8, #6a4190)',
      transform: 'translateY(-2px)',
      boxShadow: '0 6px 20px rgba(102, 126, 234, 0.4)',
    },
    '&:disabled': {
      background: 'rgba(102, 126, 234, 0.3)',
      color: 'rgba(255, 255, 255, 0.7)',
    },
  },
  signupButton: {
    color: '#667eea',
    borderColor: '#667eea',
    borderRadius: '12px',
    padding: '8px 16px',
    fontFamily: '"Poppins", sans-serif',
    fontWeight: 500,
    textTransform: 'none',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: 'rgba(102, 126, 234, 0.1)',
      borderColor: '#5a6fd8',
      transform: 'translateY(-1px)',
    },
  },
  dividerContainer: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    px: 2,
    my: 0,
  },
  divider: {
    flex: 1,
    borderColor: 'rgba(102, 126, 234, 0.3)',
  },
  dividerText: {
    mx: 2,
    color: 'rgba(102, 126, 234, 0.7)',
    fontSize: '0.875rem',
    fontFamily: '"Poppins", sans-serif',
    fontWeight: 500,
  },
  errorText: {
    mt: 2,
    textAlign: 'center',
    color: '#f44336',
    fontFamily: '"Poppins", sans-serif',
    fontSize: '0.875rem',
  },
  googleButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    mb: 0,
  },
} satisfies Record<string, SxProps>;
